export default __webpack_public_path__ + "static/media/task-reward-title.f866fb27.png";